import { getCurrencySymbol } from '@vy/services';
import { Currency } from '@vy/types';
import { formatNumberAbbreviated } from '../number';

export function formatPriceToAbbreviated(currency: Currency, value: number) {
  const formattedValue = formatNumberAbbreviated(value);
  const currencySymbol = getCurrencySymbol(currency);

  return `${currencySymbol}${formattedValue}`;
}
